import { render, staticRenderFns } from "./IssueReportDevelopmentNameModelGrouping.vue?vue&type=template&id=8e747cc4&scoped=true&"
import script from "./IssueReportDevelopmentNameModelGrouping.vue?vue&type=script&lang=js&"
export * from "./IssueReportDevelopmentNameModelGrouping.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportDevelopmentNameModelGrouping.vue?vue&type=style&index=0&id=8e747cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e747cc4",
  null
  
)

export default component.exports